export const StoreKeys = {
    ACCESS_TOKEN: "access_token",
    REFRESH_TOKEN: "refresh_token",
    TOKEN_EXPIRATION_TIME: "access_token_exp",
    BASE_INITIALIZATION_PARAMS: "baseInitializationParams",
    MODULE_INITIALIZATION_PARAMS: "moduleInitializationParams"
};


// WEBPACK FOOTER //
// ./src/components/utils/StoreKeys.js